import { render, staticRenderFns } from "./WorkflowStatus.vue?vue&type=template&id=af20e8ba&scoped=true"
import script from "./WorkflowStatus.vue?vue&type=script&lang=js"
export * from "./WorkflowStatus.vue?vue&type=script&lang=js"
import style0 from "./WorkflowStatus.vue?vue&type=style&index=0&id=af20e8ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af20e8ba",
  null
  
)

export default component.exports